/**
 * src/web/components/google-doc-page.jsx
 * Googleドキュメント表示用コンポーネント
 */

import React from 'react'
import RightSidePage from './right-side-page.jsx'
import {
  IconButton,
} from 'react-toolbox/lib/button'
import { translate } from 'react-i18next'
import { GoogleLogin } from './google-signin-provider.jsx'
import config from '../../config'

class GoogleDocPage extends React.Component {
  state = {
    googleLogin: false,
  }

	onGoogleSigninSuccess = ()=> this.setState({ googleLogin: true })

  render() {
    const {
      t,
      params,
    } = this.props

    return (
      <RightSidePage title={t('label:Googleドキュメント')} icon='insert_drive_file' scrolling="no"
        rightAction={[<IconButton icon='open_in_new' href={params.url} target='_blank' rel="noopener noreferrer" />]}>
        { !this.state.googleLogin &&
          <GoogleLogin label={t('label:Googleドキュメントに接続')} onSuccess={this.onGoogleSigninSuccess} /> ||
          <iframe style={{border: '0px', width: '100%', height: 'calc(100vh - 120px)'}} src={params.url} />
        }
      </RightSidePage>
    )
  }
}

export default translate()(GoogleDocPage)



// WEBPACK FOOTER //
// ./src/web/components/google-doc-page.jsx